import React, { useState, useContext, useEffect } from 'react'
import MenuBtDivider from '../../components/ui/menuBtDivider';
import GlobalStateContext from '../../components/GlobalStateContext';
import BtCalcularBME from './btCalcularBME';
import PrintAllFlxs from './PrintAllFlxs'
import FileSaveAs from './FileSaveAs';
import FileUploader from './FileUploader';
import FileUploaderOld from './arquivo/FileUploaderOld';
import { Box, Grid, Button } from '@mui/material';
// import BtAtingirMeta from './solver/btAtingirMeta';
import BtArquivo from './arquivo/btArquivo';
// import BtRTD from './rtd/btRTD';


function MenuBME() {
  const {area, bmeFileName, site, data} = useContext(GlobalStateContext)

    return (
        <Box>
            <Box p={1}
                sx={{
                    display: 'flex', 
                    flexDirection: 'row', 
                    justifyContent: 'space-between', 
                }}>

                <Grid  gap={3} container>
                    <BtCalcularBME/>
                    <BtArquivo/>
                    <Button variant="contained" color="primary" onClick={() => {
                        const cleanedData = cleanData(data);
                        console.log(cleanedData);
                    }}>
                        Limpar dados
                    </Button>
                    {/* <BtAtingirMeta/>
                    <BtRTD/> */}
                    
                </Grid> 
        
                <Box sx={{fontWeight: 'bold', fontSize: '14px'}}>{bmeFileName}</Box>
            </Box>
        </Box>
       
    )
}

export default MenuBME

export function cleanData(data) {
    const cleanedData = {};
  
    Object.keys(data).forEach(key => {
      const item = data[key];
      const cleanedItem = {};
  
      // Remove campos específicos
      delete item.valorDefault;
      delete item.input;
      delete item.siteId;
      delete item.screen;
      delete item.screen2;
      delete item.screen3;
      delete item.limites;
  
      // Copia apenas campos que não são null
      Object.keys(item).forEach(field => {
        if (item[field] !== null) {
          cleanedItem[field] = item[field];
        }
      });
  
      cleanedData[key] = cleanedItem;
    });
  
    return cleanedData;
  }
